"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.construct = void 0;
function construct(ctor, obj) {
    const instance = new ctor();
    for (const key in obj)
        instance[key] = obj[key];
    return instance;
}
exports.construct = construct;
//# sourceMappingURL=construct.js.map